


<div class="fof">
    <div class="">
        <img src="../../../../assets/images/404page.png" alt="404">
    </div>
    <p>Sorry, Page not found</p>
    <button mat-flat-button color="primary" [routerLink]="'/core/listing'"  > Back to home</button>
</div>